/**
 * カテゴリの絞り込みと並び順（docs/01-requirements.md §5.6 P1・§5.17 P1）。
 *
 * タイムラインと一覧で共有する。**状態そのものも共有する**（ADR-030）ので、
 * ここは受け取った `view` を描くだけにし、記憶は呼び出し側（`view-preference`）に任せる。
 */

import { useCategories } from '@app/components/useCategories';
import type { ViewState } from '@app/views/view-preference';
import type { NoteSort } from '@shared/types';

const SORT_LABEL: Record<NoteSort, string> = {
  subject: '対象日順',
  created: '作成日順',
  updated: '更新日順',
};

export interface NoteFilterBarProps {
  view: ViewState;
  onChange: (patch: Partial<ViewState>) => void;
}

export function NoteFilterBar({ view, onChange }: NoteFilterBarProps) {
  const categories = useCategories();

  return (
    <div className="toolbar">
      <label className="field field--inline note-filter__category">
        <span className="field__label">カテゴリ</span>
        <select
          className="al-select al-select--compact"
          value={view.categoryId ?? ''}
          onChange={(event) =>
            onChange({
              categoryId: event.target.value === '' ? null : Number(event.target.value),
            })
          }
        >
          <option value="">すべて</option>
          {categories.categories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
      </label>
      <label className="field field--inline">
        <span className="field__label">並び順</span>
        <select
          className="al-select al-select--compact"
          value={view.sort}
          onChange={(event) => onChange({ sort: event.target.value as NoteSort })}
        >
          {(['subject', 'created', 'updated'] as NoteSort[]).map((sort) => (
            <option key={sort} value={sort}>
              {SORT_LABEL[sort]}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
